module.exports = __webpack_public_path__ + "static/media/spin-desktop.a8fc7a9b.png";